<template>
  <div>
    <CreateNavBar :title="navbar_title"/>

    <router-view
      :companyId="companyId"
      :isOrganizer="isOrganizer"
      :redirectToLogin="redirectToLogin"
      :updateIsOrganizer="updateIsOrganizer"
      :setDataIsOrganizer="setDataIsOrganizer" />
  </div>
</template>


<script>
import { mapGetters } from 'vuex'

import CreateNavBar from '@/components/common/CreateNavBar'

import { AuthService } from '@/api/AuthService'

const auth = new AuthService()

export default {
  components: {
    CreateNavBar
  },
  data() {
    return {
      navbar_title: 'YeyPass for Business',
      companyId: auth.getCompanyId(),
      isOrganizer: auth.getIsEventOrganizer()
    }
  },
  computed:  {
    ...mapGetters(['currentUser'])
  },
  methods: {
    redirectToLogin() {
      this.$router.push('/login')
      auth.logout()
    },
    updateIsOrganizer(value) {
      auth.setIsEventOrganizer(value)
    },
    setDataIsOrganizer() {
      this.isOrganizer = auth.getIsEventOrganizer()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/business_profile/CreateBusinessProfile.vue